export function isLoadLightError(state) {
	return state.latestLoadLightError != null
}

export function isNoInternet(state) {
	return isLoadLightError(state)
		&& state.latestLoadLightError.reason === "NO INTERNET"
}

export function isToZoomedOut(state) {
	return isLoadLightError(state)
		&& state.latestLoadLightError.status === 400
}


// WEBPACK FOOTER //
// ./src/selectors/latestLoadLightError.js